<template>
  <div class="c-login-page-wrapper">
    <div class="c-login-form-wrap">
      <div class="c-has-welcome-msg"><b>Dobrodošli</b></div>
      <form v-on:submit.prevent>
        <!-- Login Username -->
        <div class="c-grid-row">
          <div class="c-form-group c-blue-style" v-bind:class="{'c-has-error' : loginForm.email.showError == true}">
            <label for="login-username" v-if="loginForm.email.showError == false">Korisničko ime</label>
            <label for="login-username" v-else>{{loginForm.email.errorMsg}}</label>
            <input type="text" class="c-form-control" id="login-username" name="login-username"
              v-model="loginForm.email.model">
          </div>
        </div>
        <!-- Login Pass -->
        <div class="c-grid-row">
          <div class="c-form-group c-blue-style" v-bind:class="{'c-has-error' : loginForm.password.showError == true}">
            <label for="login-password" v-if="loginForm.password.showError == false">Lozinka</label>
            <label for="login-password" v-else>{{loginForm.password.errorMsg}}</label>
            <input type="password" class="c-form-control" id="login-password" name="login-password"
              v-model="loginForm.password.model">
          </div>
        </div>
        <!-- Login button -->
        <div class="c-grid-row">
          <div class="c-has-submit-btn">
            <button type="submit" class="c-btn c-btn-success" v-on:click="checkLoginAccess()"><i class="fa fa-rocket" aria-hidden="true"></i> <b>Prijavi se</b></button>
          </div>
        </div>
        <!-- Remember me -->
        <div class="c-grid-row">
          <div class="c-form-group c-has-rememberme">
            <input type="checkbox" className="c-form-control" id="login-rememberme" ref="login-rememberme" placeholder="Zapamti me" />
            <label>Zapamti me</label>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import firebase from 'firebase'

  export default {
    name: 'login',
    data: function() {
      return {
        loginForm: {
          isValid: false,
          email: {
            model: null,
            inFocus: false,
            showError: false,
            //accept any character (min 2 lenght)
            //pattern: /^.{2,}$/,
            errorMsg: 'Korisničko ime je pogrešno'
          },
          password: {
            model: null,
            inFocus: false,
            showError: false,
            //accept any character (min 2 lenght)
            //pattern: /^.{2,}$/,
            errorMsg: 'Lozinka je pogrešna'
          }
        }        
      }
    },
    methods: {
      checkLoginAccess: function() {
        firebase.auth().signInWithEmailAndPassword(this.loginForm.email.model, this.loginForm.password.model).then(
          (user) => {
            this.$router.replace('gather-user-info');
          },
          (err) => {
            alert('Oops. ' + err.message)
          }
        );
      }
    },
    created: function () {
      console.log('||-created: Login');
    }
  }
</script>

<style>  /* "scoped" attribute limit the CSS to this component only */
</style>



// WEBPACK FOOTER //
// src/components/Login.vue